import {
    FETCH_MODIFIER_LOOKUP_REQUEST,
    FETCH_MODIFIER_LOOKUP_SUCCESS,
    FETCH_MODIFIER_LOOKUP_FAILURE,
  } from "./FetchModifiersLookupTypes";
  
  const initialState = {
    loading: false,
    modifierLookup: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MODIFIER_LOOKUP_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_MODIFIER_LOOKUP_SUCCESS:
        return {
          loading: false,
          modifierLookup: action.payload,
          error: "",
        };
      case FETCH_MODIFIER_LOOKUP_FAILURE:
        return {
          loading: false,
          modifierLookup: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  